<template>
  <div class="faq">
    <div class="page-header">
      <v-layout row align-center>
        <v-icon x-large color="primary">mdi-help-circle-outline</v-icon>
        <h1>Frequently Asked Questions</h1>
      </v-layout>
    </div>
    <div v-if="faqs != null && faqs.length > 0">
      <v-card v-for="item in faqs" :key="item.faqid" class="card-top">
        <v-card-title>
          <div>{{ item.question }}</div>
        </v-card-title>
        <v-card-subtitle>
          <div>
            {{ item.faqdate.toString().substring(0, 10) }}
          </div>
        </v-card-subtitle>
        <v-card-text>
          <div>{{ item.answer }}</div>
        </v-card-text>
        <v-card-actions v-if="priviledged">
          <v-spacer></v-spacer>
          <v-btn outlined class="button" @click="onEdit(item.faqid)">
            <v-icon left>mdi-pencil</v-icon>Edit
          </v-btn>
          <v-btn outlined class="button" @click="onDelete(item.faqid)">
            <v-icon left>mdi-delete</v-icon>Delete
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-if="priviledged">
        <v-card-title> <div class="title">Add FAQ</div></v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined @click="onEdit(0)">
            <v-icon left>mdi-plus</v-icon>Add
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </div>
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title>Delete the selected<br />FAQ?</v-card-title>
          <v-card-text>{{ title }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined text @click="dialog = false">No</v-btn>
            <v-btn outlined text @click="deleteFaq">Yes</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <statusalert ref="alert" returnUrl="/faq"></statusalert>
  </div>
</template>

<script>
import FaqService from '../../services/api/FaqService'
import store from '@/store/index.js'
import router from '@/router/index.js'
import statusalert from '../../components/StatusAlert'

export default {
  name: 'FAQ',

  components: {
    statusalert
  },
  store: store,

  data() {
    return {
      dialog: false,
      faqs: [],
      faqid: 0,
      title: ''
    }
  },
  created() {
    this.fetchFaqs()
  },
  computed: {
    priviledged() {
      return (
        this.$store.getters.getAdministrator || this.$store.getters.getProShop
      )
    }
  },
  methods: {
    deleteFaq() {
      this.dialog = false
      if (this.faqid > 0) {
        FaqService.delete(this.faqid)
          .then(result => {
            this.result = {
              isValid: true,
              statusCode: result.status,
              errors: ['FAQ deleted']
            }
          })
          .catch(error => {
            console.log(error)
            this.result = {
              isValid: false,
              statusCode: 404,
              errors: ['Failed to delete FAQ']
            }
          })
          .finally(() => {
            store.commit('notLoading')
            this.$refs.alert.displayResult(this.result)
            this.fetchFaqs()
          })
      }
    },

    fetchFaqs() {
      store.commit('isLoading')
      this.faqs = []
      FaqService.get()
        .then(faqs => {
          if (this.priviledged) {
            this.faqs = faqs
          } else {
            for (var i = 0; i < faqs.length; i++) {
              const faq = faqs[i]
              if (faq.active) {
                this.faqs.push(faq)
              }
            }
          }
        })
        .catch(error => console.log(error))
        .finally(() => {
          store.commit('notLoading')
        })
    },

    onEdit(faqid) {
      router.push('/faq/edit/' + faqid)
    },

    onDelete(faqid) {
      this.dialog = true
      const faq = this.faqs.find(n => n.faqid === faqid)
      this.title = ''
      this.faqid = 0
      if (faq) {
        this.faqid = faq.faqid
        this.title = faq.question
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card-top {
  margin-top: 15px;
}
</style>
